import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import ResourceHints from './components/ResourceHints';
import PerformanceMonitor from './components/PerformanceMonitor';
import HomePage from './pages/HomePage/index';
import TopMiningStocks from './pages/MiningStocks/index';
import ResearchPage from './pages/Research/index';
import ResourcesPage from './pages/Resources/index';
import AboutUsPage from './pages/AboutUs/index';
import InterviewsPage from './pages/Interviews/index';
import BlogPage from './pages/Blog/index';
import BlogPostDetail from './pages/Blog/BlogPostDetail';
import ContactUsPage from './pages/ContactUs/index';
import LandingPage from './pages/LandingPage/index';
import NotFound from './pages/NotFound/index';
import Mofu from './pages/Mofu/index';
import Footer from './components/Footer';
import CanonicalLink from './components/CanonicalLink';
import { blogPosts } from './pages/Blog/blogPostsData';
import MiningReportLanding from './pages/MiningReportLanding';
import ProtectedReportViewer from './pages/MiningReportLanding/ProtectedReportViewer';
import TopStockPick from './pages/TopStockPick';
import KingfisherLanding from './pages/KingfisherLanding';
import StockPickLanding from './pages/StockPickLanding';

const AppContent: React.FC = () => {
  const location = useLocation();
  const validRoutes = ['/', '/mining-stocks', '/research', '/resources', '/about', '/interviews', '/blog', '/contact', '/Elite-investment-club', '/mofu', '/mining-super-cycle-report', '/report-viewer', '/top-stock-pick', '/winning-stock-pick', '/top-stock-picks'];
  const isBlogPost = location.pathname.startsWith('/blog/') && location.pathname !== '/blog';
  
  // Check if blog post exists
  let isBlogPostNotFound = false;
  if (isBlogPost) {
    const blogPostSlug = location.pathname.split('/blog/')[1]?.split('/')[0];
    isBlogPostNotFound = !blogPosts.find(p => p.slug === blogPostSlug);
  }
  
  const isNotFoundPage = !validRoutes.includes(location.pathname) && !isBlogPost;
  const shouldHideNavbarFooter =
    isNotFoundPage ||
    isBlogPostNotFound ||
    location.pathname === '/Elite-investment-club' ||
    location.pathname === '/mofu' ||
    location.pathname === '/mining-super-cycle-report' ||
    location.pathname === '/report-viewer' ||
    location.pathname === '/top-stock-pick' ||
    location.pathname === '/winning-stock-pick' ||
    location.pathname === '/top-stock-picks';

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <ResourceHints 
        preloadImages={[
          '/images/Hero.webp',
          '/images/ResourcesHero.webp',
          '/images/ResearchBanner.webp',
          '/images/AboutUsBanner.webp'
        ]}
        preconnectDomains={[
          'https://the-wealthy-miner.mn.co'
        ]}
      />
      <CanonicalLink />
      <PerformanceMonitor />
      {!shouldHideNavbarFooter && <Navbar />}
      <div className="min-h-screen overflow-x-hidden">
        <React.Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-gray-500">Loading...</div></div>}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/mining-stocks" element={<TopMiningStocks />} />
            <Route path="/research" element={<ResearchPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/about" element={<AboutUsPage />} />
            <Route path="/interviews" element={<InterviewsPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostDetail />} />
            <Route path="/contact" element={<ContactUsPage />} />
            <Route path="/Elite-investment-club" element={<LandingPage />} />
            <Route path="/junior-mining-stock-investment-opportunities" element={<Mofu />} />
            <Route path="/mining-super-cycle-report" element={<MiningReportLanding />} />
            <Route path="/report-viewer" element={<ProtectedReportViewer />} />
            <Route path="/top-stock-pick" element={<TopStockPick />} />
            <Route path="/winning-stock-pick" element={<KingfisherLanding />} />
            <Route path="/top-stock-picks" element={<StockPickLanding />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </React.Suspense>
        {!shouldHideNavbarFooter && <Footer />}
      </div>
    </>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
